
<template>
  <v-app-bar app flat class="wb-navbar">
    <router-link to="/" class="wb-brand-link d-flex align-center">
      <v-img :src="logoSrc" max-width="36" class="wb-logo mr-2"></v-img>
      <span class="wb-brand">World Bank TDMA Global Knowledge Platform</span>
    </router-link>

      <v-spacer></v-spacer>
      <div class="wb-desktop-nav">
        <v-btn text to="/home" class="mx-2">Home</v-btn>
        <v-btn text to="/projects" class="mx-2" :class="{ 'wb-nav-active': isRouteActive('/projects') }">Projects</v-btn>
        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              class="mx-2"
              :class="{ 'wb-nav-active': isToolsRoute }"
              v-bind="attrs"
              v-on="on"
            >
              Tools
              <v-icon right small>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="$router.push('/tools')" :class="{ 'wb-submenu-active': isExactRoute('/tools') }">
              <v-list-item-title>EVMax</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="$router.push('/tools/flowmax')" :class="{ 'wb-submenu-active': isExactRoute('/tools/flowmax') }">
              <v-list-item-title>FlowMax</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$router.push('/tools/cyclemax')" :class="{ 'wb-submenu-active': isExactRoute('/tools/cyclemax') }">
              <v-list-item-title>CycleMax</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$router.push('/tools/path')" :class="{ 'wb-submenu-active': isExactRoute('/tools/path') }">
              <v-list-item-title>PATH</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      
        <!-- Data Menu with Submenu -->
        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              class="mx-2"
              :class="{ 'wb-nav-active': isDataRoute }"
              v-bind="attrs"
              v-on="on"
            >
              Data
              <v-icon right small>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="$router.push('/performance-indicators')" :class="{ 'wb-submenu-active': isExactRoute('/performance-indicators') }">
              <v-list-item-title>Performance Indicators of Transport</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$router.push('/critical-mineral')" :class="{ 'wb-submenu-active': isExactRoute('/critical-mineral') }">
              <v-list-item-title>Critical Mineral</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$router.push('/gender-mobility')" :class="{ 'wb-submenu-active': isExactRoute('/gender-mobility') }">
              <v-list-item-title>Gender and Mobility</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$router.push('/rai')" :class="{ 'wb-submenu-active': isExactRoute('/rai') }">
              <v-list-item-title>Rural Access Index (RAI)</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <v-menu offset-y left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            class="wb-mobile-menu-btn"
            v-bind="attrs"
            v-on="on"
            aria-label="Open navigation menu"
          >
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>
        <v-list class="wb-mobile-menu">
          <v-list-item to="/home">
            <v-list-item-icon><v-icon>mdi-home-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>
          <v-list-item to="/projects" :class="{ 'wb-submenu-active': isExactRoute('/projects') }">
            <v-list-item-icon><v-icon>mdi-folder-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Projects</v-list-item-title>
          </v-list-item>
          <v-list-item to="/tools" :class="{ 'wb-submenu-active': isExactRoute('/tools') }">
            <v-list-item-icon><v-icon>mdi-tools</v-icon></v-list-item-icon>
            <v-list-item-title>EVMax</v-list-item-title>
          </v-list-item>
          <v-list-item to="/tools/flowmax" :class="{ 'wb-submenu-active': isExactRoute('/tools/flowmax') }">
            <v-list-item-icon><v-icon>mdi-chart-sankey</v-icon></v-list-item-icon>
            <v-list-item-title>FlowMax</v-list-item-title>
          </v-list-item>
          <v-list-item to="/tools/cyclemax" :class="{ 'wb-submenu-active': isExactRoute('/tools/cyclemax') }">
            <v-list-item-icon><v-icon>mdi-bike</v-icon></v-list-item-icon>
            <v-list-item-title>CycleMax</v-list-item-title>
          </v-list-item>
          <v-list-item to="/tools/path" :class="{ 'wb-submenu-active': isExactRoute('/tools/path') }">
            <v-list-item-icon><v-icon>mdi-map-marker-path</v-icon></v-list-item-icon>
            <v-list-item-title>PATH</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="$router.push('/performance-indicators')" :class="{ 'wb-submenu-active': isExactRoute('/performance-indicators') }">
            <v-list-item-icon><v-icon>mdi-chart-line</v-icon></v-list-item-icon>
            <v-list-item-title>Performance Indicators</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$router.push('/critical-mineral')" :class="{ 'wb-submenu-active': isExactRoute('/critical-mineral') }">
            <v-list-item-icon><v-icon>mdi-atom-variant</v-icon></v-list-item-icon>
            <v-list-item-title>Critical Mineral</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$router.push('/gender-mobility')" :class="{ 'wb-submenu-active': isExactRoute('/gender-mobility') }">
            <v-list-item-icon><v-icon>mdi-human-female-boy</v-icon></v-list-item-icon>
            <v-list-item-title>Gender and Mobility</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$router.push('/rai')" :class="{ 'wb-submenu-active': isExactRoute('/rai') }">
            <v-list-item-icon><v-icon>mdi-map-marker-path</v-icon></v-list-item-icon>
            <v-list-item-title>Rural Access Index</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    
  </v-app-bar>
</template>

<script>
export default {
  name: "NavBar",
  props: {
    logoSrc: { type: String, default: require('@/assets/images/wb-square.png') }
  },
  computed: {
    isToolsRoute() {
      return this.$route.path.startsWith('/tools')
    },
    isDataRoute() {
      return [
        '/performance-indicators',
        '/critical-mineral',
        '/gender-mobility',
        '/rai',
      ].includes(this.$route.path)
    },
  },
  methods: {
    isExactRoute(path) {
      return this.$route.path === path
    },
    isRouteActive(path) {
      return this.$route.path === path || this.$route.path.startsWith(`${path}/`)
    },
  },
}
</script>

<style scoped>
.wb-navbar {
  /* background-color: #009FDA; */
  /* background: linear-gradient(90deg, #009FDA, #009FDA); */
  color: #fff;
}
.wb-brand {
  font-weight: 700;
  letter-spacing: .5px;
  font-size: 1.1rem;
}
.wb-brand-link {
  text-decoration: none;
  min-width: 0;
}
.wb-desktop-nav {
  display: flex;
  align-items: center;
}
.wb-mobile-menu-btn {
  display: none;
}
a { color: inherit; }

.wb-nav-active {
  background: rgba(0, 83, 159, 0.1);
  color: #00539f !important;
  font-weight: 700;
}

.wb-submenu-active {
  background-color: rgba(47, 128, 237, 0.12);
}

.wb-submenu-active .v-list-item__title,
.wb-submenu-active .v-icon {
  color: #00539f !important;
  font-weight: 700;
}

/* Submenu Styles */
.v-list-item {
  cursor: pointer;
}

.v-list-item:hover {
  background-color: #f5f5f5;
}

.v-list-item-title {
  font-size: 0.9rem;
  white-space: nowrap;
}

.v-menu__content {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

@media (max-width: 700px) {
  .wb-brand {
    display: none;
  }

  .wb-logo {
    margin-right: 0 !important;
  }

  .wb-navbar .v-toolbar__content {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .wb-desktop-nav {
    display: none;
  }

  .wb-mobile-menu-btn {
    display: inline-flex;
  }
}

@media (max-width: 460px) {
  .wb-navbar .v-toolbar__content {
    padding-left: 6px !important;
    padding-right: 6px !important;
  }
}
</style>
